// src/data/polls.js
export const POLLS_DATA = [
  {
    id: 'mvp-2025',
    question: 'Who will win NBA MVP in 2025?',
    options: [
      { id: 'lebron', text: 'LeBron James' },
      { id: 'jokic', text: 'Nikola Jokić' },
      { id: 'giannis', text: 'Giannis Antetokounmpo' },
      { id: 'luka', text: 'Luka Dončić' },
    ],
  },
  {
    id: 'world-series-2025',
    question: 'Who will win the 2025 World Series?',
    options: [
      { id: 'yankees', text: 'New York Yankees' },
      { id: 'dodgers', text: 'Los Angeles Dodgers' },
      { id: 'braves', text: 'Atlanta Braves' },
      { id: 'phillies', text: 'Philadelphia Phillies' },
    ],
  },
  {
    id: 'super-bowl-2025',
    question: 'Who will win Super Bowl LIX?',
    options: [
      { id: 'chiefs', text: 'Kansas City Chiefs' },
      { id: 'eagles', text: 'Philadelphia Eagles' },
      { id: '49ers', text: 'San Francisco 49ers' },
      { id: 'bills', text: 'Buffalo Bills' },
    ],
  },
];
